<template>
  <section class="domain">
    <navigation-bar>
      <navigation-link
        icon="icon_search"
        :label="$t('dj-流程列表')"
        :to="{ name: 'workflow-list', params: { clusterName } }"
      />
      <navigation-link
        :label="$t('dj-设置')"
        icon="icon_settings"
        :to="{ name: 'domain-settings', params: { clusterName } }"
      />
      <feature-flag display="inline" name="domainMetrics">
        <navigation-link
          label="Metrics"
          icon="icon_chart"
          :to="{ name: 'domain-metrics', params: { clusterName } }"
        />
      </feature-flag>
    </navigation-bar>
    <router-view
      name="workflow-list"
      :cluster-name="clusterName"
      :date-format="dateFormat"
      :domain="domain"
      :time-format="timeFormat"
      :timezone="timezone"
    />
    <router-view
      name="domain-settings"
      :cluster-name="clusterName"
      :domain="domain"
    />
    <router-view
      name="domain-metrics"
      :cluster-name="clusterName"
      :domain="domain"
    />
    <router-view
      name="workflow-archival"
      :cluster-name="clusterName"
      :date-format="dateFormat"
      :domain="domain"
      :time-format="timeFormat"
      :timezone="timezone"
    />
  </section>
</template>
<script>
import { FeatureFlag, NavigationBar, NavigationLink } from "@/components";

export default {
  components: {
    "feature-flag": FeatureFlag,
    "navigation-bar": NavigationBar,
    "navigation-link": NavigationLink,
  },
  props: ["clusterName", "dateFormat", "domain", "timeFormat", "timezone"],
};
</script>

<style lang="stylus">
section.domain {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: auto;
}
</style>
